import "./video-alert.css";

import { LiveLikeVideoAlert } from "@livelike/engagementsdk";
import { videoManager } from "../../utils";
import { state } from "lit/decorators.js";

const html = (window as any).html;

interface IAttributes {
  key: string;
  value: string;
}

class SBSVideoAlert extends LiveLikeVideoAlert {
  @state() videoId: string = "";
  @state() videoElement: HTMLVideoElement | null = null;

  firstUpdated() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!isSafari) return;

    setTimeout(() => {
      const video: HTMLVideoElement | null =
        this.querySelector("livelike-video video") ||
        this.querySelector("livelike-widget-body video") ||
        this.querySelector(".sbs-custom-video");

      if (!video) return;

      const thumbnailUrl = this.getThumbnailUrl();

      // Update poster and enforce Safari playback attributes
      video.poster = "";
      video.poster = thumbnailUrl;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "true");
      video.setAttribute("x-webkit-airplay", "allow");
      video.load();
    }, 0);
  }

  connectedCallback() {
    super.connectedCallback();
    this.setupVideoManager();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.cleanupVideoManager();
  }

  setupVideoManager() {
    // Generate unique video ID based on widget ID or timestamp
    this.videoId =
      this.widgetPayload?.id || `video-${Date.now()}-${Math.random()}`;

    // Wait for video element to be available
    setTimeout(() => {
      this.videoElement =
        this.querySelector("livelike-video video") ||
        this.querySelector("livelike-widget-body video") ||
        this.querySelector(".sbs-custom-video");

      if (this.videoElement) {
        videoManager.registerVideo(this.videoId, this.videoElement);
      }
    }, 100);
  }

  cleanupVideoManager() {
    if (this.videoId) {
      videoManager.unregisterVideo(this.videoId);
    }
  }

  getThumbnailUrl(): string {
    const thumbnailAttr = this.widgetPayload?.widget_attributes?.find(
      (attr: IAttributes) => attr.key === "thumbnail"
    );
    return thumbnailAttr?.value ?? "";
  }

  render() {
    const { title = "", video_url: videoUrl = "" } = this.widgetPayload ?? {};
    const thumbnailUrl = this.getThumbnailUrl();

    if (!title && !videoUrl) {
      return null;
    }

    return html`
      <template kind="video-alert">
        <livelike-widget-root class="custom-widget">
          <livelike-widget-header class="widget-header" slot="header">
            <livelike-title class="custom-title"></livelike-title>
          </livelike-widget-header>

          <livelike-widget-body>
            <livelike-video class="no-footer" src="${videoUrl}">
              <video
                id="video"
                class="sbs-custom-video"
                src="${videoUrl}"
                poster="${thumbnailUrl}"
                muted
                playsinline
                preload="metadata"
                controls
                webkit-playsinline="true"
                x-webkit-airplay="allow"
              >
                <source type="video/mp4" src="${videoUrl}" />
              </video>
            </livelike-video>
          </livelike-widget-body>
        </livelike-widget-root>
      </template>
    `;
  }
}
customElements.define("sbs-video-alert", SBSVideoAlert as any);
